import { useQuery } from "@tanstack/react-query";
import { useThoughtSpotAPI } from "@/api";

export function useSearchDataFeatureDataSources() {
  const thoughtSpotAPI = useThoughtSpotAPI();

  return useQuery({
    queryKey: ["search-data-data-sources"],
    queryFn: async () => {
      const resp = await thoughtSpotAPI.getThoughtspotSearchDataDataSources();
      return resp.data;
    },
  });
}
